// src/features/agent-builder/components/WizardStepCard.tsx
import React from 'react';
import { Card } from '@dopomogai/ui';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

interface WizardStepCardProps {
  titleKey: string;
  descriptionKey?: string;
  titleOptions?: Record<string, any>;
  descriptionOptions?: Record<string, any>;
  children: React.ReactNode;
  className?: string;
  headerContentInCard?: React.ReactNode;
  headerBgColor?: string; // <-- ADD THIS NEW PROP
}

export const WizardStepCard: React.FC<WizardStepCardProps> = ({
  titleKey,
  descriptionKey,
  titleOptions,
  descriptionOptions,
  children,
  className,
  headerContentInCard,
  headerBgColor, // <-- DESTRUCTURE THE NEW PROP
}) => {
  const { t } = useTranslation('agentBuilder');

  const resolvedTitle = t(titleKey, titleOptions);
  const resolvedDescription = descriptionKey ? t(descriptionKey, descriptionOptions) : null;

  return (
    <Card
      title={resolvedTitle}
      actionButton={headerContentInCard}
      className={clsx(className)}
      headerBgColor={headerBgColor} // <-- PASS THE PROP TO THE CARD
    >
      {resolvedDescription && (
        <div 
          className={clsx(
            "px-6 md:px-8 pb-4",
            "text-sm text-slate-600",
            "border-b border-slate-300 pt-0"
          )}
        >
          {resolvedDescription}
        </div>
      )}
      <div className={clsx(
          {"p-6 md:p-8": !resolvedDescription}
      )}>
        {children}
      </div>
    </Card>
  );
};